import { useLocalSearchParams } from 'expo-router';

import { DeferredRedirect } from '../../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const params = useLocalSearchParams();

  return <DeferredRedirect href={{ pathname: '/account/gift', params }} />;
}
